/** "a" or "an" for a word a sentence is about to name. Added after the journey walk (2026-10-31)
 * found *"A Admin always needs a second factor"* on the last step of joining a workspace.
 *
 * Decided by the first letter, which is right for every word this product puts after an article
 * (Admin, Approver, Auditor, Activity record, Initiative, Obligation) and wrong for the English
 * exceptions that start with a vowel but sound like a consonant ("user", "one", "unit"). There are
 * none in the role or record-kind vocabularies; a table of exceptions here would be a second home
 * for words that do not occur. */
export function withArticle(word: string, { capital = false }: { capital?: boolean } = {}): string {
  const article = /^[aeiou]/i.test(word.trim()) ? "an" : "a";
  return `${capital ? article.charAt(0).toUpperCase() + article.slice(1) : article} ${word}`;
}
